import { createContext } from 'react';

import { GroupContextType } from '../utils/groupContextType';

export interface GroupContextState {
    groupId: string | null;
    companyIds: string[];
    type: GroupContextType | null;
}

export interface GroupContextValue extends GroupContextState {
    name: string | null;
    setGroupContext: (nextState: GroupContextState) => void;
    clearGroupContext: () => void;
}

export const GroupContext = createContext<GroupContextValue | null>(null);
